module.exports = __webpack_public_path__ + "img/logo.31b96c03.svg";